import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/user-logo.png'
import _imports_1 from '../../assets/radio-checked.png'
import _imports_2 from '../../assets/radio.png'


const _withScopeId = n => (_pushScopeId("data-v-0e09cfec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "identity-pop" }
const _hoisted_2 = {
  class: "identity-info",
  style: {"overflow":"auto"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "info-name bj-flexitem-1 bj-flex-start" }
const _hoisted_5 = { class: "bj-flexitem-1 bj-flex-start" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "info-logo",
  src: _imports_0
}, null, -1))
const _hoisted_7 = { class: "merchant-name" }
const _hoisted_8 = {
  key: 0,
  class: "merchant-status"
}
const _hoisted_9 = {
  key: 0,
  class: "radio-img",
  src: _imports_1
}
const _hoisted_10 = {
  key: 1,
  class: "radio-img",
  src: _imports_2
}
const _hoisted_11 = { class: "info-role" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "role-title" }, "我的身份", -1))
const _hoisted_13 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.title,
      width: "50%",
      class: "identity-header",
      "close-on-click-modal": false,
      "show-close": false,
      "z-index": 99
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_el_button, { onClick: _ctx.logout }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.userAdd
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userIndentity, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass(["infinite-item", { 'item-active': _ctx.merchantId == item.merchantId }]),
              onClick: ($event: any) => (_ctx.userTouch(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.companyType === 1 ? "集团：" : item.companyType === 2 ? "门店：" : "") + _toDisplayString(item.merchantName), 1),
                  (item.applyStatus&&item.applyStatus!==2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        (item.applyStatus==1)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("审核中")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (item.applyStatus==4)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("审核拒绝")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.merchantId == item.merchantId)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.roleName ? item.roleName.split(',') : [], (tag) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: tag,
                    style: {"margin":"8px 8px 0px 0px"},
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}